"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _variables = require("../common/variables.js");

var _utils = require("../common/utils.js");

var _useTheme = _interopRequireDefault(require("../useTheme"));

var _useTranslatedLabels = _interopRequireDefault(require("../useTranslatedLabels"));

var _BackgroundColorContext = require("../BackgroundColorContext");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var alertIcons = {
  close: /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  })),
  info: /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "23",
    height: "23",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
  })),
  success: /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "23",
    height: "23",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
  })),
  warning: /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "23",
    height: "23",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
  })),
  error: /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "23",
    height: "23",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z",
    fill: "currentColor"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }))
};

var DxcAlert = function DxcAlert(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? "info" : _ref$type,
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? "inline" : _ref$mode,
      _ref$inlineText = _ref.inlineText,
      inlineText = _ref$inlineText === void 0 ? "" : _ref$inlineText,
      onClose = _ref.onClose,
      children = _ref.children,
      margin = _ref.margin,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "fitContent" : _ref$size,
      tabIndex = _ref.tabIndex;
  var colorsTheme = (0, _useTheme["default"])();
  var translatedLabels = (0, _useTranslatedLabels["default"])();

  var getTypeText = function getTypeText() {
    return type === "info" ? translatedLabels.alert.infoTitleText : type === "confirm" ? translatedLabels.alert.successTitleText : type === "warning" ? translatedLabels.alert.warningTitleText : translatedLabels.alert.errorTitleText;
  };

  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: colorsTheme.alert
  }, /*#__PURE__*/_react["default"].createElement(AlertModal, {
    mode: mode
  }, mode === "modal" && /*#__PURE__*/_react["default"].createElement(OverlayContainer, {
    mode: mode,
    onClick: onClose
  }), /*#__PURE__*/_react["default"].createElement(AlertContainer, {
    mode: mode,
    type: type,
    margin: margin,
    size: size
  }, /*#__PURE__*/_react["default"].createElement(AlertInfo, null, /*#__PURE__*/_react["default"].createElement(AlertIcon, {
    type: type
  }, type === "info" && alertIcons.info || type === "confirm" && alertIcons.success || type === "warning" && alertIcons.warning || type === "error" && alertIcons.error), /*#__PURE__*/_react["default"].createElement(AlertText, null, /*#__PURE__*/_react["default"].createElement(AlertTitle, {
    type: type
  }, getTypeText()), inlineText && inlineText !== "" && "-", /*#__PURE__*/_react["default"].createElement(AlertInlineText, null, inlineText)), onClose && /*#__PURE__*/_react["default"].createElement(AlertCloseAction, {
    onClick: onClose,
    tabIndex: tabIndex
  }, alertIcons.close)), children && /*#__PURE__*/_react["default"].createElement(AlertContent, null, /*#__PURE__*/_react["default"].createElement(_BackgroundColorContext.BackgroundColorProvider, {
    color: type === "info" && colorsTheme.alert.infoBackgroundColor || type === "confirm" && colorsTheme.alert.successBackgroundColor || type === "warning" && colorsTheme.alert.warningBackgroundColor || type === "error" && colorsTheme.alert.errorBackgroundColor
  }, children)))));
};

var sizes = {
  small: "280px",
  medium: "480px",
  large: "820px",
  fillParent: "100%",
  fitContent: "fit-content"
};

var calculateWidth = function calculateWidth(margin, size) {
  return size === "fillParent" ? "calc(".concat(sizes[size], " - ").concat((0, _utils.getMargin)(margin, "left"), " - ").concat((0, _utils.getMargin)(margin, "right"), ")") : sizes[size];
};

var AlertModal = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  font-size: ", ";\n  width: ", ";\n  height: ", ";\n  justify-content: ", ";\n  align-items: ", ";\n  top: ", ";\n  left: ", ";\n  position: ", ";\n  display: ", ";\n  z-index: ", ";\n"])), function (props) {
  return props.theme.fontSizeBase;
}, function (props) {
  return props.mode === "modal" ? "100%" : "";
}, function (props) {
  return props.mode === "modal" ? "100%" : "";
}, function (props) {
  return props.mode === "modal" ? "center" : "";
}, function (props) {
  return props.mode === "modal" ? "center" : "";
}, function (props) {
  return props.mode === "modal" ? "0" : "";
}, function (props) {
  return props.mode === "modal" ? "0" : "";
}, function (props) {
  return props.mode === "modal" ? "fixed" : "";
}, function (props) {
  return props.mode === "modal" ? "flex" : "";
}, function (props) {
  return props.mode === "modal" ? "1200" : "";
});

var OverlayContainer = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  background-color: ", ";\n  position: ", ";\n  top: ", ";\n  bottom: ", ";\n  left: ", ";\n  right: ", ";\n"])), function (props) {
  return props.mode === "modal" ? "".concat(props.theme.overlayColor) : "transparent";
}, function (props) {
  return props.mode === "modal" ? "fixed" : "";
}, function (props) {
  return props.mode === "modal" ? "0" : "";
}, function (props) {
  return props.mode === "modal" ? "0" : "";
}, function (props) {
  return props.mode === "modal" ? "0" : "";
}, function (props) {
  return props.mode === "modal" ? "0" : "";
});

var AlertContainer = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  margin: ", ";\n  margin-top: ", ";\n  margin-right: ", ";\n  margin-bottom: ", ";\n  margin-left: ", ";\n  display: ", ";\n  overflow: hidden;\n  box-sizing: border-box;\n\n  background-color: ", ";\n\n  border-radius: ", ";\n  border-width: ", ";\n  border-style: ", ";\n  border-color: ", ";\n\n  padding-left: 12px;\n  padding-right: 12px;\n  justify-content: ", ";\n  align-items: ", ";\n  max-width: ", ";\n  width: ", ";\n  z-index: ", ";\n"])), function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) !== "object" ? _variables.spaces[props.margin] : "0px";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.top ? _variables.spaces[props.margin.top] : "";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.right ? _variables.spaces[props.margin.right] : "";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.bottom ? _variables.spaces[props.margin.bottom] : "";
}, function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) === "object" && props.margin.left ? _variables.spaces[props.margin.left] : "";
}, function (props) {
  return props.size === "fitContent" ? "inline-block" : "block";
}, function (props) {
  return props.type === "info" && props.theme.infoBackgroundColor || props.type === "confirm" && props.theme.successBackgroundColor || props.type === "warning" && props.theme.warningBackgroundColor || props.type === "error" && props.theme.errorBackgroundColor;
}, function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return props.theme.borderThickness;
}, function (props) {
  return props.theme.borderStyle;
}, function (props) {
  return props.type === "info" && props.theme.infoBorderColor || props.type === "confirm" && props.theme.successBorderColor || props.type === "warning" && props.theme.warningBorderColor || props.type === "error" && props.theme.errorBorderColor;
}, function (props) {
  return props.mode === "modal" ? "center" : "";
}, function (props) {
  return props.mode === "modal" ? "center" : "";
}, function (props) {
  return props.size !== "fillParent" && calculateWidth(props.margin, "fillParent");
}, function (props) {
  return props.size !== "fillParent" && calculateWidth(props.margin, props.size);
}, function (props) {
  return props.mode === "modal" ? "1300" : "";
});

var AlertInfo = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-direction: row;\n  height: calc(48px - calc(", " * 2));\n  align-items: center;\n  width: 100%;\n"])), function (props) {
  return props.theme.borderThickness;
});

var AlertTitle = _styledComponents["default"].div(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  margin-right: 8px;\n  padding-right: ", ";\n  padding-left: ", ";\n  font-family: ", ";\n  font-size: ", ";\n  font-style: ", ";\n  font-weight: ", ";\n  color: ", ";\n  text-transform: ", ";\n"])), function (props) {
  return props.theme.titlePaddingRight;
}, function (props) {
  return props.theme.titlePaddingLeft;
}, function (props) {
  return props.theme.titleFontFamily;
}, function (props) {
  return props.theme.titleFontSize;
}, function (props) {
  return props.theme.titleFontStyle;
}, function (props) {
  return props.theme.titleFontWeight;
}, function (props) {
  return props.theme.titleFontColor;
}, function (props) {
  return props.theme.titleTextTransform;
});

var AlertInlineText = _styledComponents["default"].div(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n  margin-left: 8px;\n  padding-right: ", ";\n  padding-left: ", ";\n  flex-grow: 1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-family: ", ";\n  font-size: ", ";\n  font-style: ", ";\n  font-weight: ", ";\n  color: ", ";\n"])), function (props) {
  return props.theme.inlineTextPaddingRight;
}, function (props) {
  return props.theme.inlineTextPaddingLeft;
}, function (props) {
  return props.theme.inlineTextFontFamily;
}, function (props) {
  return props.theme.inlineTextFontSize;
}, function (props) {
  return props.theme.inlineTextFontStyle;
}, function (props) {
  return props.theme.inlineTextFontWeight;
}, function (props) {
  return props.theme.inlineTextFontColor;
});

var AlertIcon = _styledComponents["default"].span(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-wrap: wrap;\n  align-content: center;\n  margin-right: 12px;\n  padding-right: ", ";\n  padding-left: ", ";\n\n  color: ", ";\n\n  svg {\n    width: ", ";\n    height: ", ";\n  }\n"])), function (props) {
  return props.theme.iconPaddingRight;
}, function (props) {
  return props.theme.iconPaddingLeft;
}, function (props) {
  return props.type === "info" && props.theme.infoIconColor || props.type === "confirm" && props.theme.successIconColor || props.type === "warning" && props.theme.warningIconColor || props.type === "error" && props.theme.errorIconColor;
}, function (props) {
  return props.theme.iconSize;
}, function (props) {
  return props.theme.iconSize;
});

var AlertText = _styledComponents["default"].div(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-direction: row;\n  flex-grow: 1;\n  align-items: center;\n  overflow: hidden;\n"])));

var AlertContent = _styledComponents["default"].div(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2["default"])(["\n  flex: 1 1 auto;\n  padding: ", ";\n  overflow-y: auto;\n"])), function (props) {
  return "".concat(props.theme.contentPaddingTop, " ").concat(props.theme.contentPaddingRight, " ").concat(props.theme.contentPaddingBottom, " ").concat(props.theme.contentPaddingLeft);
});

var AlertCloseAction = _styledComponents["default"].button(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-wrap: wrap;\n  align-content: center;\n  height: 24px;\n  width: 24px;\n  border: 1px solid transparent;\n  border-radius: 2px;\n  box-shadow: 0 0 0 2px transparent;\n  padding: 3px;\n  margin-left: 12px;\n  background-color: transparent;\n  color: #000000;\n  cursor: pointer;\n\n  &:hover {\n    background-color: ", ";\n  }\n  &:focus {\n    outline: none;\n    box-shadow: 0 0 0 2px ", ";\n  }\n  &:focus-visible {\n    outline: none;\n    box-shadow: 0 0 0 2px ", ";\n  }\n  &:active {\n    background-color: ", ";\n  }\n"])), function (props) {
  return props.theme.hoverActionBackgroundColor;
}, function (props) {
  return props.theme.focusActionBorderColor;
}, function (props) {
  return props.theme.focusActionBorderColor;
}, function (props) {
  return props.theme.activeActionBackgroundColor;
});

var _default = DxcAlert;
exports["default"] = _default;